import createAction from '@wix/communities-blog-client-common/dist/src/services/create-action';
import { getViewMode, getExternalId } from '../services/wix-sdk-utils';

export const FETCH_APP_SETTINGS_PRESETS_REQUEST = 'appSettingsPresets/FETCH_REQUEST';
export const FETCH_APP_SETTINGS_PRESETS_SUCCESS = 'appSettingsPresets/FETCH_SUCCESS';
export const FETCH_APP_SETTINGS_PRESETS_FAILURE = 'appSettingsPresets/FETCH_FAILURE';

export const fetchAppSettingsPresetsRequest = createAction(FETCH_APP_SETTINGS_PRESETS_REQUEST);
export const fetchAppSettingsPresetsSuccess = createAction(FETCH_APP_SETTINGS_PRESETS_SUCCESS);
export const fetchAppSettingsPresetsFailure = createAction(FETCH_APP_SETTINGS_PRESETS_FAILURE);

export function fetchAppSettingsPresets(search) {
  return (dispatch, getState, { request }) => {
    dispatch(fetchAppSettingsPresetsRequest());

    const viewMode = getViewMode(search) || 'site';

    const promise = request(`/_api/settings/presets?externalId=${getExternalId(search)}&viewMode=${viewMode}`);
    return promise
      .then(
        presets => dispatch(fetchAppSettingsPresetsSuccess(presets)),
        () => dispatch(fetchAppSettingsPresetsFailure()),
      )
      .then(() => promise);
  };
}
